const EVENT_PER_PAGE = 8;
const EVENT_REGEX = '/content/events/';

module.exports = {
  EVENT_PER_PAGE,
  EVENT_REGEX,
};
